export enum PageTypes {
    'candidates',
    'jobPreview'
}

export type PropsType = {
    activePage: PageTypes
}